import React, {useCallback} from "react";
import styled from "@emotion/styled";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { COLORS, COLORS_BASE } from "../../utils/consts";

type SquareCheckboxProps = {
    checkboxId: string,
    isCheckboxChecked: boolean,
    checkboxLabel: string,
    onSelectCheckbox: ((e: React.FormEvent<HTMLInputElement>) => void),
    type?: "checkbox" | "radio"
}

function SquareCheckbox({checkboxId, isCheckboxChecked, checkboxLabel, onSelectCheckbox, type = "radio"}: SquareCheckboxProps) {
  // const selectCheckbox = useCallback(
  //   (e: React.FormEvent<HTMLInputElement>) => {
  //    onSelectCheckbox()
  //   },
  //   [layerArray, mapCurrent, setSelectedLayer]
  // );
  
  return (
    <BaseLayerStyle active={isCheckboxChecked}>
      <CheckboxStyle
        type={type}
        value={checkboxId}
        id={checkboxId}
        checked={isCheckboxChecked}
        onChange={onSelectCheckbox}
      />

      <LabelStyle htmlFor={checkboxId}>
        <FontAwesomeIcon
          icon={isCheckboxChecked ? "circle-dot" : ["far", "circle"]}
          color={isCheckboxChecked ? COLORS.ICON.MAIN:COLORS.FONT.INACTIVE}
        />
        {checkboxLabel}
      </LabelStyle>
    </BaseLayerStyle>
  );
}

export default SquareCheckbox;

const LabelStyle = styled.label<{}>(
  () => `
    &:hover{
      cursor: pointer;
    }
    > svg{
        padding: 0 10px 0 0;
    }
`
);

const BaseLayerStyle = styled.div<{ active?: boolean }>(({ active=true }) => `
    margin: 10px 0;
    padding: 0;
    &:hover{
      cursor: pointer;
    }
    ${!active && `color: ${COLORS.FONT.INACTIVE};`}
`)

const CheckboxStyle = styled.input<{}>(() => `
    display: none;
    &:hover{
      cursor: pointer;
    }
`)
